import { EnumInNumberSourceControl } from '../@xmcloud/types';
import { IGetSourceControlAccessToken } from '../app/models/accessToken';

export const SourceControlAccessTokenMock: IGetSourceControlAccessToken = {
	accessToken: 'ghu_OBMtFsdfsfsYX4W39T22Oi3OGvKYq0iuxtY',
	expiresIn: 3600,
	provider: EnumInNumberSourceControl.GitHub,
};
